export const sortByDate = (a: { date: string }, b: { date: string }) =>
  new Date(b.date).valueOf() - new Date(a.date).valueOf();
